export default __webpack_public_path__ + "static/media/stage.937611e5.svg";